/* eslint-disable max-len */
/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */

/**
 * Email Icon
 *
 * @file EmailIcon.jsx
 * @author Gladson Samuel S
 * @since 0.0.1
 */

import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import PropType from 'prop-types';

const EmailIcon = ({ className }) => (
  <SvgIcon className={className} xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12" fill="none">
    <path fillRule="evenodd" clipRule="evenodd" d="M1.75 0.312744H12.25C13.2165 0.312744 14 1.09625 14 2.06274V9.93774C14 10.9042 13.2165 11.6877 12.25 11.6877H1.75C0.783502 11.6877 0 10.9042 0 9.93774V2.06274C0 1.09625 0.783502 0.312744 1.75 0.312744ZM12.3509 1.86902C12.3205 1.85304 12.2859 1.84399 12.2492 1.84399H1.74916C1.71244 1.84399 1.67784 1.85304 1.64746 1.86902L5.81064 5.32933C6.49954 5.90192 7.49878 5.90192 8.18767 5.32933L12.3509 1.86902ZM12.4688 3.76318L9.16729 6.50725C7.91107 7.55139 6.08893 7.55139 4.83271 6.50725L1.53125 3.76318V9.93808C1.53125 10.0589 1.62919 10.1568 1.75 10.1568H12.25C12.3708 10.1568 12.4688 10.0589 12.4688 9.93808V3.76318Z" fill="#0D004D" />
  </SvgIcon>
);

EmailIcon.propTypes = {
  className: PropType.string.isRequired
};

export default EmailIcon;

